module.exports = __webpack_public_path__ + "static/media/FOUR.65d8ee09.png";